import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { DatePickerCustomHeaderComponent } from "@app/components/material/matDatePicker/date-picker-custom-header.component"
import { DateAdapter } from "@angular/material/core";
import { enUS } from "date-fns/locale";
import { AppDate } from "@app/util/app-date";

export const CUSTOM_DATE_FORMATS = {
    parse: {
        dateInput: 'LL',
    },
    display: {
        dateInput: 'MM/dd/yyyy',
        monthYearLabel: 'yyyy',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'yyyy',
        headerDisplay: 'MMMM yyyy'
    },
};

export type DATE_PICKER_CONFIG = {

    /** Default date to set as the input value */
    defaultDate: AppDate

    /** Minimum date to enable for input */
    minDate: AppDate

    /** Function to check if a given date should be enabled */
    isDateEnabled: (date: AppDate) => boolean

    /** Called based on how the user pages the months, so that holidays can be preloaded (or deleted to relieve confusion) */
    preloadYear: (year: number) => Promise<any>

    /** Validate a date to display error or such */
    validateDate: (date: AppDate) => any;
}

@Component({
    selector: 'app-mat-date-picker',
    template: require('./mat-date-picker.component.html')
})
export class MatDatePickerComponent implements OnInit, OnChanges{

    @Input() tidValue: string;
    @Input() idValue: string;
    @Input() labelText: string;
    @Input() required: boolean;
    @Input() config: DATE_PICKER_CONFIG;

    @Output() onDateChange = new EventEmitter<any>();

    datePickerCustomHeader = DatePickerCustomHeaderComponent;

    viewError: unknown;
    dateValue: unknown;

    minDate: Date;

    constructor(@Inject(DateAdapter<any>) private _adapter: DateAdapter<any>) {
        this._adapter.setLocale(enUS);
    }

    ngOnInit() {
        if(this.config && this.config.minDate) {
            this.minDate = this.config.minDate.jsDate;
            this.dateValue = this.config.defaultDate.jsDate;
            this.onDateChange.emit(this.config.defaultDate);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes.config && !changes.config.firstChange && changes.config.currentValue.defaultDate){
            this.dateValue = changes.config.currentValue.defaultDate.jsDate;
            this.onDateChange.emit(changes.config.currentValue.defaultDate);
        }
    }

    validateAndEmit() {
        const newValue = AppDate.fromDate(this.dateValue as Date);
        this.onDateChange.emit(newValue);
    }

    dateFilter = (d: Date | null): boolean => {
        if(d != null && this.config) {
            return this.config.isDateEnabled(AppDate.fromDate(d));
        }
    };

    /** Us this to identify the mat-dialog-content and add an id and tid if not already there **/
    calendarOpened() {
        const htmlCollection = document.getElementsByTagName('mat-datepicker-content')
        if(htmlCollection && htmlCollection.length > 0) {
            const datePickerElement = htmlCollection[0];
            datePickerElement.id = 'templateModalDate'
            datePickerElement.setAttribute('tid', 'templateModalDate');
        }
    }
}
